var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Loading_Ani",
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.057,
    height: 206.669,
    viewBox: "0 0 198.057 206.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 21.528,
    cy: 21.528,
    r: 21.528,
    transform: "translate(73.195 0)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 19.375,
    cy: 19.375,
    r: 19.375,
    transform: "translate(136.24 27.373)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 17.222,
    cy: 17.222,
    r: 17.222,
    transform: "translate(163.613 90.418)",
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 15.07,
    cy: 15.07,
    r: 15.07,
    transform: "translate(140.545 153.462)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_40",
    "data-name": "Ellipse 40",
    cx: 12.917,
    cy: 12.917,
    r: 12.917,
    transform: "translate(81.806 180.835)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 10.764,
    cy: 10.764,
    r: 10.764,
    transform: "translate(23.067 157.768)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 8.611,
    cy: 8.611,
    r: 8.611,
    transform: "translate(0 99.029)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 6.458,
    cy: 6.458,
    r: 6.458,
    transform: "translate(27.373 40.29)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.e30ed5f98ef490216286a527eff96025.svg";
export { ForwardRef as ReactComponent };